// extracted by mini-css-extract-plugin
module.exports = {"required":"Label_required__p8igD","label":"Label_label__DemmB","circleNumber":"Label_circleNumber__Ki2-c","text":"Label_text__Bm-4Y","description":"Label_description__129C-"};